import { Button } from "@/components/ui/button";
import moment from "moment";

export function PrtReportingDetailHandler({ currentExport, data, dataSave, exportToExcel }) {
  if (currentExport == "prt reporting") {
    const exportData = dataSave.part_request_tickets
      .filter((obj) => {
        if (data.date_from && data.date_to) {
          return moment(obj.created_at).isBetween(
            data.date_from,
            data.date_to,
          );
        } else {
          return true;
        }
      })
      .filter((obj) => {
        if (data.customer_id) {
          return obj.service_order_ticket.customer_id == data.customer_id;
        } else {
          return true;
        }
      })
      .map((obj) => {
        return {
          "PRT No": obj.pr_ticket_no,
          "SOT No": obj.service_order_ticket?.so_ticket_no,
          "SE Code": obj.service_order_ticket?.on_duty_service_engineer?.code,
          "LOG Code": obj.prt_status_works.find(
            (sw) => sw.status_work_code === "PRD",
          )?.updated_by
            ? obj.prt_status_works.find((sw) => sw.status_work_code === "PRD")
                ?.updated_by
            : "-",
          "Open Time": obj.prt_status_works.find(
            (sw) => sw.status_work_code === "PRO",
          )?.created_at
            ? moment(
                obj.prt_status_works.find(
                  (sw) => sw.status_work_code === "PRO",
                )?.created_at,
              )
                .subtract(7, "hours")
                .format("YYYY-MM-DD HH:mm:ss")
            : "-",
          "Accepted Time": obj.prt_status_works.find(
            (sw) => sw.status_work_code === "PRA",
          )?.created_at
            ? moment(
                obj.prt_status_works.find(
                  (sw) => sw.status_work_code === "PRA",
                )?.created_at,
              )
                .subtract(7, "hours")
                .format("YYYY-MM-DD HH:mm:ss")
            : "-",
          "Prepare Time": obj.prt_status_works.find(
            (sw) => sw.status_work_code === "PRP",
          )?.created_at
            ? moment(
                obj.prt_status_works.find(
                  (sw) => sw.status_work_code === "PRP",
                )?.created_at,
              )
                .subtract(7, "hours")
                .format("YYYY-MM-DD HH:mm:ss")
            : "-",
          "list of part delivered": obj.part_transfers.map((pt) => {
            return `${moment(pt.created_at)
              .subtract(7, "hours")
              .format("YYYY-MM-DD HH:mm:ss")} - ${
              pt.part_details.part_number
            } - ${pt.part_details.name} - ${
              pt.part_quantity ? pt.part_quantity : 1
            }`;
          }),
          "list of part received": obj.part_receiveds.map((pt) => {
            return `${moment(pt.created_at)
              .subtract(7, "hours")
              .format("YYYY-MM-DD HH:mm:ss")} - ${
              pt.part_details.part_number
            } - ${pt.part_details.name} - ${
              pt.part_quantity ? pt.part_quantity : 1
            }`;
          }),
        };
      });

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `prt_detail_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
